import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Users from './OrgUsers';
import Peers from './OrgPeers';
import Admin from './OrgAdmins';
import Roles from '../helpers/Roles';


const tabs = {
  SERVICE_USERS: 'service_users',
  PEERS: 'peers',
  ADMIN: 'admin',
};


// Shows list/table of all an organization's service users
class People extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: '',
    };
  }

  componentDidMount() {
    this.setState({ tab: tabs.SERVICE_USERS });
  }

  addNew = () => {
    this.props.history.push({
      pathname: '/createAccount',
    });
  }

  // resetPasswords = () => {
  //   this.props.resetAllPasswords([...this.props.orgUsers, ...this.props.orgPeers, ...this.props.orgAdmins]);
  // }

  setTab = (tab) => {
    this.setState({ tab });
  }

  renderTableTabs = () => {
    // const { user, orgID } = this.props.location.state;
    return (
      <Tabs
        activeKey={this.state.tab}
        onSelect={this.setTab}
        id="peopleTabs"
      >
        { (this.props.role === Roles.ADMIN) ? <Tab className="peopleTab" eventKey={tabs.SERVICE_USERS} title="Tjenestebrukere"> <Users /> </Tab>
          : <Tab className="peopleTab" eventKey={tabs.SERVICE_USERS} title="Service Users"> <Users /> </Tab>
        }
        {/* <Tab eventKey={tabs.ADMIN} title="Admins">
          <Admin user={user} orgID={orgID} />
        </Tab> */}
        { (this.props.role === Roles.ADMIN) ? <Tab className="peopleTab" eventKey={tabs.PEERS} title="Likepersoner"> <Peers /> </Tab>
          : <Tab className="peopleTab" eventKey={tabs.PEERS} title="Peer specialist"> <Peers /></Tab>
        }
        { (this.props.role === Roles.ADMIN) ? <Tab className="peopleTab" eventKey={tabs.ADMIN} title="Admin"><Admin /></Tab>
          : <Tab className="peopleTab" eventKey={tabs.ADMIN} title="Admin"> <Admin /></Tab>
        }
      </Tabs>
    );
  }


  render() {
    return (
      <div className="page view">
        <div className="pageHeader">
          <div>
            {(this.props.role === Roles.ADMIN) ? <h1> Brukere og ansatte </h1> : <h1>Users & Staff</h1>}
            {(this.props.role === Roles.ADMIN) ? <p>Administrer deltakere her</p> : <p> Manage other members in your organization here </p> }

          </div>
          {/* <Button className="resetAllPasswordsButton" id="purplebackground" onClick={this.resetPasswords}>
            Reset all passwords
          </Button> */}
          { (this.props.role === Roles.ADMIN) ? <Button className="addButton" id="purplebackground" onClick={this.addNew}>  +Legg til ny </Button>
            : <Button className="addButton" id="purplebackground" onClick={this.addNew}> + Add new </Button> }
        </div>
        {/* <div>
          <Button onClick={this.sortByName}>Sort by name</Button>
        </div> */}
        <div className="table">
          {/* <p>Show: </p> */}
          {this.renderTableTabs()}
        </div>
      </div>
    );
  }
}
const mapStateToProps = reduxState => (
  {
    orgID: reduxState.orgs.selectedOrgID,
    orgAdmins: reduxState.users.orgAdmins,
    role: reduxState.auth.role,
  }
);


export default withRouter(connect(mapStateToProps, { })(People));
